module.exports = __webpack_public_path__ + "img/location-crosshairs.4a9cf472.svg";